module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.302266c8.mp3";